<template>
  <div class="soha-table-overflow-hidden">
    <div class="row soha-table-header soha-table-display-none">
      <div class="col-3">
        {{ $t(`${I18nPrefix}HEADER_TITLE`) }}
      </div>
      <div class="col-3">
        {{ $t(`${I18nPrefix}HEADER_USER`) }}
      </div>
      <div class="col-2 d-flex justify-content-center">
        {{ $t(`${I18nPrefix}HEADER_NUMBER`) }}
      </div>
      <div class="col-2 d-flex justify-content-center">
        {{ $t(`${I18nPrefix}HEADER_PRIORITY`) }}
      </div>
      <div class="col-2 d-flex justify-content-end">
        {{ $t(`${I18nPrefix}HEADER_STATUS`) }}
      </div>
    </div>
    <div
      class="soha-table-tbody-tr row soha-gap-mob cursor-pointer"
      v-for="(recruitmentRequest, index) in recruitmentRequests"
      :key="index"
      @click="
        $router.push({
          name: 'recruitment-request-show',
          query: { id: recruitmentRequest.id },
        })
      "
    >
      <div class="col-sm-3 col-12 soha-table-tbody-td align-items-center">
        <div class="col-sm-1 col-1">
          <span class="text-bold">{{ toPersianDigits(index + 1) }}</span>
        </div>
        <div class="col-sm-11 col-11 soha-max-width-fit-mob">
          <soha-limited-text
            class="soha-table-title"
            :text="recruitmentRequest.title"
            :limit="30"
          />
          <soha-limited-text
            class="soha-table-detail"
            :text="
              recruitmentRequest.recruitmentReason
                ? recruitmentRequest.recruitmentReason.name
                : $t(`${I18nPrefix}NOT_SELECTED`)
            "
            :limit="30"
          />
        </div>
      </div>
      <div
        class="col-sm-3 col-12 soha-table-tbody-td justify-content-start soha-justify-content-center-mob align-items-center"
      >
        <soha-avatar
          :baseUrl="$employerImageUrl"
          :imageUrl="
            recruitmentRequest.user ? recruitmentRequest.user.img : image
          "
          :gender="
            recruitmentRequest.user
              ? recruitmentRequest.user.genderId
              : genderId
          "
          :color-hash-input="employerName(recruitmentRequest)"
          :size="40"
        />
        <div class="col-sm-11 col-11 soha-max-width-fit-mob">
          <soha-limited-text
            class="soha-table-title"
            :text="
              recruitmentRequest.user
                ? recruitmentRequest.user.firstName +
                  ' ' +
                  recruitmentRequest.user.lastName
                : fullName
            "
            :limit="30"
          />
          <soha-limited-text
            v-if="
              (recruitmentRequest.user && recruitmentRequest.user.post) || post
            "
            class="soha-table-detail"
            :text="
              recruitmentRequest.user ? recruitmentRequest.user.post : post
            "
            :limit="30"
          />
          <soha-limited-text
            v-else
            class="soha-table-detail"
            :text="$t(`${I18nPrefix}UNKNOWN_POST`)"
            :limit="30"
          />
        </div>
      </div>
      <div class="col-sm-2 soha-table-tbody-td flex-column">
        <span class="soha-table-title text-center"
          >{{ toPersianDigits(+recruitmentRequest.number) }}
          {{ $t(`${I18nPrefix}PERSON`) }}</span
        >
        <soha-limited-text
          class="soha-table-detail text-center"
          :text="getGenderType(recruitmentRequest.genderId).name"
          :limit="30"
        />
      </div>
      <div class="col-sm-2 col-12 soha-table-tbody-td text-left">
        <soha-emergency-level :level="+recruitmentRequest.priority" />
      </div>
      <div
        class="col-sm-2 soha-table-tbody-td justify-content-end soha-justify-content-center-mob"
      >
        <soha-status-label
          :color="getLastStatus(recruitmentRequest.lastStatus).color"
          :label="getLastStatus(recruitmentRequest.lastStatus).name"
        />
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/components/recruitment-request/recruitment-request.css";
import UIMixin from "@/mixins/UIMixin";

export default {
  name: "RecruitmentRequestTable",
  mixins: [UIMixin],
  props: {
    recruitmentRequests: Array,
    fullName: String,
    post: String,
    image: String,
    genderId: String,
  },
  data() {
    return {
      I18nPrefix: "PAGES.RECRUITMENT_REQUEST.INDEX.",
      statuses: [
        {
          id: 1,
          name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.WAITING_ITEMS`),
          color: "yellow",
        },
        {
          id: 2,
          name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.CONFIRM_ITEMS`),
          color: "green",
        },
        {
          id: 3,
          name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.REJECT_ITEMS`),
          color: "red",
        },
        {
          id: 4,
          name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.DELAY_ITEMS`),
          color: "blue",
        },
        {
          id: 5,
          name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.PUBLISH_ITEMS`),
          color: "navy-blue",
        },
        {
          id: 6,
          name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.CANCEL_ITEMS`),
          color: "pink",
        },
      ],
      genders: [
        {
          id: null,
          name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.NOT_SELECTED`),
        },
        { id: 1, name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.WOMEN`) },
        { id: 2, name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.MEN`) },
        {
          id: 3,
          name: this.$t(`PAGES.RECRUITMENT_REQUEST.INDEX.WOMEN_OR_MEN`),
        },
      ],
    };
  },

  methods: {
    getLastStatus(status) {
      return this.statuses.find((elem) => +elem.id === +status);
    },
    getGenderType(genderId) {
      return this.genders.find((elem) => elem.id == genderId);
    },
    employerName(recruitmentRequest) {
      return (
        this.fullName ??
        recruitmentRequest.user.firstName +
          " " +
          recruitmentRequest.user.lastName
      );
    },
  },
};
</script>
